import { NgModule} from '@angular/core';
import { UpgradeModule } from '@angular/upgrade/static';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';
import { UIRouterModule, UIRouter } from '@uirouter/angular';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import { GoogleMapsModule } from '@angular/google-maps';
import { AgmCoreModule } from '@agm/core';

import { TokenInterceptorService } from './core/services/token-interceptor.service';
import { EncodeHttpParamsInterceptor } from './core/services/encode-http-params-interceptor.service';

import { modalServiceProvider, projectServiceProvider, authenticationServiceProvider, monitoringStoreServiceProvider, configurationStoreServiceProvider, timeZoneServiceProvider, tripOverviewServiceProvider, SqiServiceProvider, zabbixOverviewServiceProvider, monitoringTrainDetailsServiceProvider, $rootScopeProvider, trainTypeServiceProvider, filterStorageProvider, zabbixIssueProvider, trainScheduleExportServiceProvider, trainMaintainerServiceProvider} from '../ajs-upgraded-providers';

import { IncidentsModule } from './features/incidents/incidents.module';
import { ConfigurationsModule } from './features/configurations/configurations.module';
import { UsersModule } from './features/users/users.module';
import { MonitoringModule } from './features/monitoring/monitoring.module';
import { SimsModule } from './features/sims/sims.module';
import { DiagtoolModule } from './features/diagtool/diagtool.module';
import { TrainsModule } from './features/trains/trains.module';
import { LayoutModule } from './layout/layout.module';
import { PoolsModule } from './features/pools/pools.module';
import { ToastrModule } from 'ngx-toastr';
import { ReferenceAreasModule } from './features/reference-areas/reference-areas.module';
import { AuthModule } from './features/auth/auth.module';

import { AnalysisModule } from './features/analysis/analysis.module';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationService } from 'primeng/api';

import { TrainSchedulesModule } from './features/train-schedules/train-schedules.module';
import { ReportingModule } from './features/reporting/reporting.module';
import {TrainConnectivityModule} from './features/connectivities/TrainConnectivity.module';

import { registerLocaleData } from '@angular/common';
import localeDe from "@angular/common/locales/de"
import localeEn from "@angular/common/locales/en"
import localeIt from "@angular/common/locales/it"
import localeFr from "@angular/common/locales/fr"

registerLocaleData(localeDe);
registerLocaleData(localeEn);
registerLocaleData(localeIt);
registerLocaleData(localeFr);
@NgModule({
  declarations: [AppComponent],
  entryComponents: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    UpgradeModule,
    UIRouterUpgradeModule,
    NgbModule,
    HttpClientModule,
    GoogleMapsModule,
    AgmCoreModule.forRoot({
      apiKey: ''
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    }),
    UIRouterModule.forChild({ states: [] }),
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-bottom-center',
      preventDuplicates: true,
    }),
    LayoutModule,
    AuthModule,
    MonitoringModule,
    SimsModule,
    PoolsModule,
    UsersModule,
    DiagtoolModule,
    TrainsModule,
    ReferenceAreasModule,
    AnalysisModule,
    IncidentsModule,
    ConfigurationsModule,
    TrainSchedulesModule,
    ReportingModule,
    TrainConnectivityModule
  ],
  providers: [{
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EncodeHttpParamsInterceptor,
      multi: true
    },
    ConfirmationService,
    projectServiceProvider,
    modalServiceProvider,
    authenticationServiceProvider,
    monitoringStoreServiceProvider,
    configurationStoreServiceProvider,
    timeZoneServiceProvider,
    tripOverviewServiceProvider,
    zabbixOverviewServiceProvider,
    SqiServiceProvider,
    MessageService,
    DialogService,
    monitoringTrainDetailsServiceProvider,
    $rootScopeProvider,
    trainTypeServiceProvider,
    trainMaintainerServiceProvider,
    filterStorageProvider,
    zabbixIssueProvider,
    trainScheduleExportServiceProvider
],

})
export class AppModule { 
  constructor(private router: UIRouter) {
    // "router" needed in constructor to bootstrap angular states
   }

  ngDoBootstrap() {
    //this.upgrade.bootstrap(document.body, [sampleAppModuleAngularJS.name], { strictDi: true });
  }
}

// AOT compilation support
export function httpTranslateLoader(http: HttpClient) {
  const pathname = window.location.pathname;
  return new TranslateHttpLoader(http, pathname + "assets/i18n/", ".json");
}
